import { Component, Input, OnInit } from '@angular/core';
import { ModalOpenerService } from 'src/app/modals/modal-opener.service';
import { CreditSummaryModel } from 'src/app/models/CreditSummary.model';
import { DossierService } from 'src/app/services/dossier.service';

@Component({
  selector: 'app-request-credit-summary',
  templateUrl: './request-credit-summary.component.html'
})
export class RequestCreditSummaryComponent implements OnInit {

  @Input() requestGuid!: string;
  creditSummary!: CreditSummaryModel;
  
  public get displayModalIcon(): boolean {
    return (this.creditSummary && this.creditSummary.totalCosts > 0);
  }

  constructor(private modalOpenerService: ModalOpenerService, private requestApiClient: DossierService) {
  }

  ngOnInit(): void {
    // this.requestApiClient.GetCreditSummary(this.requestGuid).subscribe(
    //   summary => {
    //     this.creditSummary = summary;
    //   }
    // )
  }
  
  openSummaryExplanationModal() {
    this.modalOpenerService.Open_CreditSummaryExplanation(this.creditSummary);
  }

}
